"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Conductor = (function () {
    function Conductor(_a) {
        var confetti = _a.confetti, getTickAnimation = _a.getTickAnimation, decorateOptions = _a.decorateOptions;
        var _this = this;
        this.interval = null;
        this.shoot = function () {
            return _this.getTickAnimation(_this.confetti, _this.decorateOptions);
        };
        this.run = function (_a) {
            var speed = _a.speed, _b = _a.delay, delay = _b === void 0 ? 0 : _b, duration = _a.duration;
            if (_this.interval) {
                return;
            }
            setTimeout(function () {
                _this.shoot();
                _this.interval = setInterval(_this.shoot, 1000 / Math.min(speed, 1000));
                if (duration) {
                    setTimeout(_this.pause, duration);
                }
            }, delay);
        };
        this.pause = function () {
            clearInterval(_this.interval);
            _this.interval = null;
        };
        this.stop = function () {
            _this.pause();
            _this.confetti.reset();
        };
        this.confetti = confetti;
        this.getTickAnimation = getTickAnimation;
        this.decorateOptions = decorateOptions;
    }
    return Conductor;
}());
exports.default = Conductor;
